import React, { useContext } from 'react';
import ErrorMessage from 'src/components/error-message';
import MetaTags from 'src/components/meta-tags';
import { AppContext } from 'src/components/app-context';

export const PageNotFound = () => {
  const { t } = useContext(AppContext);

  return (
    <>
      <ErrorMessage status={404} />
      <MetaTags
        metaTags={{
          title: `${t('errors', 'internal.unknown')} (${404})`,
        }}
      />
    </>
  );
};
